var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoccerFootball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_469_7161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.10573 9.8548L0.828125 12.7572C0.951051 14.6031 1.53247 16.3891 2.51973 17.9536L6.87453 18.376L8.65893 15.92L7.29332 10.8892L4.10573 9.8548Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8802 18.8156L17.2098 19.1716L15.7354 22.5576C17.7747 21.8315 19.5611 20.5321 20.8802 18.8156Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5992 15.5988L15.916 10.7484L12 8.08321L8.08398 10.7484L9.40038 15.5988H14.5992Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4803 18.846L14.6999 16.4H9.29988L7.52148 18.8472L9.27068 22.8636C11.0618 23.3137 12.9364 23.3137 14.7275 22.8636L16.4803 18.846Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26612 22.5576L6.79132 19.1716L3.12012 18.8156C4.43944 20.5323 6.22632 21.8317 8.26612 22.5576Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77522 5.6584C1.54488 7.44032 0.861083 9.54246 0.807617 11.7072L3.57042 9.2604L2.77522 5.6584Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56296 10.1356L11.6002 7.38799V3.82799L7.82776 1.60919C6.11358 2.30122 4.59633 3.40495 3.41016 4.82279L4.35336 9.09399L7.56296 10.1356Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1929 11.7072C23.1394 9.54235 22.4556 7.4401 21.2253 5.658L20.4297 9.2604L23.1929 11.7072Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1822 1.2632C13.1055 0.645605 10.894 0.645605 8.81738 1.2632L11.9998 3.136L15.1822 1.2632Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4004 7.38799L16.438 10.1356L19.6472 9.09559L20.59 4.82399C19.404 3.40563 17.8867 2.30146 16.1724 1.60919L12.4004 3.82879V7.38799Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1716 12.7572L19.894 9.8548L16.7064 10.8892L15.3408 15.92L17.1248 18.3752L21.48 17.9536C22.4672 16.3891 23.0486 14.603 23.1716 12.7572Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_469_7161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccerFootball);
export default __webpack_public_path__ + "static/media/soccer___football.8b581037302b2f99fae7a99f19a9bd24.svg";
export { ForwardRef as ReactComponent };